import React, { useState, useEffect } from "react";
import { Select, DatePicker } from "antd";
function Language() {
   const [hotelList, setHotelList] = useState([]);
  const LanguageList = [
    {
      id: 1,
      name: "VN",
    },
    {
      id: 2,
      name: "ENG",
    },
  ];
  const { Option } = Select;
  return (
    <div className="language">
      <Select defaultValue="VN">
        {LanguageList.map((option) => (
          <Option value={option.id} key={option.id}>
            {option.name}
          </Option>
        ))}
      </Select>
    </div>
  );
}
export default Language;
